(() => {
  if (window.EmslandrostProductLayout) return;
  const instances = new Map();
  function init(scope = document) {
    instances.forEach((observer, root) => {
      if (!root.isConnected) { observer.disconnect(); instances.delete(root); }
    });
    const roots = [...scope.querySelectorAll('.em-product-layout')];
    if (scope.matches?.('.em-product-layout')) roots.push(scope);
    roots.forEach(root => {
      if (instances.has(root)) return;
      const improve = () => {
        const service = root.querySelector('[data-em-service-details]');
        if (!service) return;
        // Move the existing legal text intact; never recreate or remove it.
        root.querySelectorAll('.product-info details').forEach(details => {
          const title = details.querySelector('summary')?.textContent.trim();
          if (title?.startsWith('Ihre gesetzlichen Gewährleistungsrechte') && !service.contains(details)) {
            service.append(details.closest('.eu-guarantee-product') || details);
          }
        });
      };
      const observer = new MutationObserver(improve);
      observer.observe(root, { childList: true, subtree: true });
      instances.set(root, observer);
      improve();
    });
  }
  window.EmslandrostProductLayout = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((observer, root) => {
      if (event.target.contains(root)) { observer.disconnect(); instances.delete(root); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
